import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

import { EXTERNAL_SERVICES, SERVICES, ESB, BANNER, GET_MICROSOFT_PROFILE_PICTURE } from './constants';

@Injectable()
export class LocatorService {

  constructor() { }

  public getPhoto(username: string): string {
    return this.buildURL(this.getHost(), EXTERNAL_SERVICES, SERVICES, ESB, BANNER, GET_MICROSOFT_PROFILE_PICTURE, username);
  }

  public getHost(): string{
    return environment.localhostUrl !== null && environment.localhostUrl !== undefined ? environment.localhostUrl : window.location.origin;
  }

  private buildURL(...urlElements): string {
    return urlElements.reduce(function (accumulator, currentValue) {
      return accumulator + '/' + currentValue;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/locator.service.ts